import './TicketOverviewFilter.less';

import { dispatch, useReframe } from 'nike-re-framejs';
import React from 'react';

import { fireGAEvent } from '@/analytics';
import RadioButton from '@/common/components/RadioButton';
import i18n from '@i18n';
import TicketStateLostIcon from 'nike-ui/src/icons/svg/ticket-state-lost-icon-sv.svg';
import TicketStateRegisteredIcon from 'nike-ui/src/icons/svg/ticket-state-registered-icon-sv.svg';
import TicketStateStornoIcon from 'nike-ui/src/icons/svg/ticket-state-storno-icon-sv.svg';
import TicketStateWonIcon from 'nike-ui/src/icons/svg/ticket-state-won-icon-sv.svg';
import { DialogBody, DialogTitle, Docked } from '@/ui/dialogs/Dialog';
import PopupNg from '@/ui/PopupNg';
import { registerPopup } from '@/ui/popupRegistrar';
import { FilteringDropdown } from '@/nikeone/components/FilterSlider';

export const { VSETKY, VYHERNEVYPLATENE, NEVYHERNE, PRIJATE, STORNOVANE, ODKUP } = {
    VSETKY: 'all',
    VYHERNEVYPLATENE: 'won',
    NEVYHERNE: 'Lost',
    PRIJATE: 'Registered',
    STORNOVANE: 'Cancelled',
    ODKUP: 'Cashin'
};

const ActionTrackingInfo = {
    [VSETKY]: {
        trackAction: 'Vsetky podane tikety'
    },
    [VYHERNEVYPLATENE]: {
        trackAction: 'Vyherne podane tikety'
    },
    [NEVYHERNE]: {
        trackAction: 'Nevyherne podane tikety'
    },
    [PRIJATE]: {
        trackAction: 'Nevyhodnotene podane tikety'
    },
    [STORNOVANE]: {
        trackAction: 'Stornovane podane tikety'
    },
    [ODKUP]: {
        trackAction: 'Odkupene podane tikety'
    }
};

function FilterDialog() {
    const derefSub = useReframe();
    const filter = derefSub(['ticketus/overview/filter']);
    const status = filter.get('status') || VSETKY;
    const cashinsRunning = derefSub(['ticketus/cashin/list/running']);

    function onChange(status) {
        const action = ActionTrackingInfo[status];
        fireGAEvent('Tikety podane', action ? action.trackAction : null, 'Filter');
        dispatch(['ticketus/overview/change-filter', { status }]);
        setTimeout(PopupNg.dispatcher.close, 200);
    }

    return (
        <Docked>
            <DialogTitle>
                <h2>{i18n('ticketus.filter.status')}</h2>
            </DialogTitle>
            <DialogBody className="filter-tickets-wrap">
                <RadioButton active={status === VSETKY} onClick={() => onChange(VSETKY)}>
                    {i18n('ticketus.filter.all')}
                </RadioButton>
                <RadioButton active={status === PRIJATE} onClick={() => onChange(PRIJATE)}>
                    <TicketStateRegisteredIcon />
                    {i18n('ticketus.filter.registered')}
                </RadioButton>
                <RadioButton active={status === VYHERNEVYPLATENE} onClick={() => onChange(VYHERNEVYPLATENE)}>
                    <TicketStateWonIcon />
                    {i18n('ticketus.filter.won')}
                </RadioButton>
                <RadioButton active={status === NEVYHERNE} onClick={() => onChange(NEVYHERNE)}>
                    <TicketStateLostIcon />
                    {i18n('ticketus.filter.lost')}
                </RadioButton>
                <RadioButton active={status === STORNOVANE} onClick={() => onChange(STORNOVANE)}>
                    <TicketStateStornoIcon />
                    {i18n('ticketus.filter.cancelled')}
                </RadioButton>
                {cashinsRunning.size > 0 ? (
                    <RadioButton active={status === ODKUP} onClick={() => onChange(ODKUP)}>
                        <div className="filter-icon-cashin">€</div>
                        {i18n('ticketus.filter.cashin')}
                    </RadioButton>
                ) : null}
            </DialogBody>
        </Docked>
    );
}

registerPopup('mytickets/filter', () => <FilterDialog />);

export default function TicketsOverviewFilterButton() {
    const derefSub = useReframe();
    const filter = derefSub(['ticketus/overview/filter']);
    const filterStatus = filter ? filter.get('status') : 'all';
    const active = filterStatus !== 'all';

    function openFilter() {
        PopupNg.dispatcher.open('mytickets/filter');
    }

    return <FilteringDropdown active={active} onClick={openFilter} label={i18n('ticketus.filter.' + filterStatus)} />;
}
